<template>
  <v-container class="edit-doorphone-page" fluid>
    <v-breadcrumbs :items="breadcrumbs" class="px-0 pt-0 pb-2" />
    <div class="edit-doorphone-header">
      <h1 class="edit-doorphone-header__title">Редактирование домофона</h1>
      <v-btn
        color="primary"
        outlined
        class="edit-doorphone-header__btn text-none"
        dark
        rounded
        @click.prevent="returnDoorphone()"
      >
        <v-icon left>mdi-eye-outline</v-icon>
        Просмотр домофона
      </v-btn>
    </div>

    <div v-if="Object.keys(doorphone).length !== 0" class="edit-doorphone-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="edit-doorphone-tabs" grow show-arrows="mobile">
        <template v-for="tab in filterTabs()">
          <v-tab
            v-if="tab.show && isDisplayInfoDoorphone"
            :key="tab.route"
            :disabled="tab.isDisabled"
            class="edit-doorphone-tab"
          >
            <v-icon v-if="tab.icon" left small class="edit-doorphone-tab__icon">{{ tab.icon }}</v-icon>
            {{ tab.name }}
          </v-tab>
        </template>
      </v-tabs>
    </div>

    <v-tabs-items v-if="Object.keys(doorphone).length !== 0" v-model="activeTab" class="edit-doorphone-tabs-items">
      <template v-for="tab in filterTabs()">
        <v-tab-item
          v-if="tab.show && isDisplayInfoDoorphone"
          :key="tab.route"
        >
          <v-card class="edit-doorphone-block mt-0" flat outlined>
            <div class="edit-doorphone-tab-content pa-4">
              <component
                :is="tab.component"
                :returnDoorphone="() => returnDoorphone()"
              />
            </div>
          </v-card>
        </v-tab-item>
      </template>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Relay from './components/Relay.vue';
import GeneralInfo from './components/GeneralInfo/GeneralInfo.vue';
import SetupPlan from './components/SetupPlan/SetupPlan.vue';
import SoundSetup from './components/SoundSetup/SoundSetup.vue';
import TimeSetup from './components/TimeSetup.vue';
import OverallSetup from './components/additionalSetup/OverallSetup.vue';
import AdministrationCode from './components/AdministrationCode.vue';
import Analytics from '@/components/doorphone/EditDoorphone/components/Analytics';
import Doors from '@/components/doorphone/EditDoorphone/components/Doors';
import AnalogLine from '@/components/doorphone/EditDoorphone/components/AnalogLine';
import AdditionalEntrance from '@/components/doorphone/EditDoorphone/components/AdditionalEntrance';

export default {
  name: 'DoorphoneEdit',
  props: ['id', 'tabId'],
  data () {
    return {
      isDisplayInfoDoorphone: true,
      isDisabled: false,
      activeTab: this.$route.params.tabId || 0,
      breadcrumbs: [
        { text: 'Домофоны', disabled: false, href: '/doorphones' },
        { text: 'Редактирование домофона', disabled: true, href: 'breadcrumbs_link_1' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          icon: 'mdi-information-outline',
          component: GeneralInfo,
          route: 'EditDoorphoneGeneralInfoTab',
          show: true,
          isDisabled: false,
        },
        {
          name: 'Квартиры',
          icon: 'mdi-home-city-outline',
          component: SetupPlan,
          route: 'EditDoorphoneSetupPlanTab',
          show: !this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Настройки',
          icon: 'mdi-cog-outline',
          component: AdministrationCode,
          route: 'EditDoorphoneAdministrationCodeTab',
          show: !this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: this.VerificationBeward ? 'Аналоговая линия' : 'Звук',
          icon: this.VerificationBeward ? 'mdi-phone-outline' : 'mdi-volume-high',
          component: SoundSetup,
          route: 'EditDoorphoneSoundSetupTab',
          show: !this.VerificationRV3434 && !this.displayTabsAkuvox,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Время',
          icon: 'mdi-clock-outline',
          component: TimeSetup,
          route: 'EditDoorphoneTimeSetupTab',
          show: !this.Verification,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Замки',
          icon: 'mdi-lock-outline',
          component: Relay,
          route: 'EditDoorphoneRelayTab',
          show: !this.Verification,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Двери',
          icon: 'mdi-door-open',
          component: Doors,
          route: 'EditDoorphoneDoors',
          show: true,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Аналоговая линия',
          icon: 'mdi-phone-outline',
          component: AnalogLine,
          route: 'EditAnalogLine',
          show: this.VerificationRV3434,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Аналитика',
          icon: 'mdi-chart-line',
          component: Analytics,
          route: 'EditDoorphoneAnalytics',
          show: false,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          name: 'Дополнительно',
          icon: 'mdi-tune-variant',
          component: OverallSetup,
          route: 'EditDoorphoneAdditionalSetupTab',
          show: true,
          isDisabled: this.doorphone.physical_status === 5,
        },
        {
          name: 'Дополнительный вход',
          icon: 'mdi-door',
          component: AdditionalEntrance,
          route: 'EditDoorphoneEntrance',
          show: this.VerificationTypeDoorphone,
          isDisabled: this.isDoorphoneDisabled || this.isadditionalEntrances,
        },
      ];
    },
    VerificationRV3434 () {
      return this.doorphoneEditInfo?.doorphone?.model === 'RV-3434';
    },
    VerificationBeward () {
      return this.doorphoneEditInfo?.doorphone?.manufacturer === 'Beward';
    },
    VerificationTypeDoorphone () {
      return this.doorphoneEditInfo?.doorphone?.type === 'M';
    },
    Verification () {
      const d = this.doorphoneEditInfo?.doorphone;
      return d?.model === 'RV-3434' || d?.manufacturer === 'Beward' || d?.manufacturer === 'Akuvox';
    },
    displayTabsAkuvox () {
      return this.doorphoneEditInfo?.doorphone?.manufacturer === 'Akuvox';
    },
    isadditionalEntrances () {
      return Array.isArray(this.doorphone.additionalEntrances) && this.doorphone.additionalEntrances.length > 0;
    },
    isDoorphoneDisabled () {
      return this.doorphone.physical_status === 6 || this.doorphone.physical_status === 5;
    },
  },
  async created () {
    this.isDisplayInfoDoorphone = false;
    await this.getInfoDoorphoneEdit({ id: this.id })
      .then(() => {
        this.isDisplayInfoDoorphone = true;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации о домофоне');
      });
  },
  methods: {
    ...mapActions({
      getInfoDoorphoneEdit: 'Doorphone/getInfoDoorphoneEdit',
      getDoorphone: 'Doorphone/getDoorphone',
    }),
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    filterTabs () {
      return this.tabs.filter(tab => this.$canRoute(tab.route));
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-doorphone-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.edit-doorphone-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.edit-doorphone-header__btn {
  text-transform: none;
  font-weight: 500;
}

.edit-doorphone-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.edit-doorphone-tabs {
  box-shadow: none;
}

.edit-doorphone-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.edit-doorphone-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.edit-doorphone-tab__icon {
  margin-right: 4px;
}

.edit-doorphone-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.edit-doorphone-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.edit-doorphone-tabs ::v-deep .v-tabs-bar__prev,
.edit-doorphone-tabs ::v-deep .v-tabs-bar__next {
  flex: 0 0 auto;
  min-width: 44px;
}

.edit-doorphone-tabs-items {
  background: transparent;
}

.edit-doorphone-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.edit-doorphone-tab-content {
  min-height: 200px;
}

@media screen and (max-width: 600px) {
  .edit-doorphone-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .edit-doorphone-header__title {
    font-size: 1.4rem;
  }
}
</style>
